module.exports = __webpack_public_path__ + "1792395595471/fonts/Flaticon.89ed3c6.ttf";